import { render, staticRenderFns } from "./ag-grid-wrapper.vue?vue&type=template&id=e26a1c20"
import script from "./ag-grid-wrapper.vue?vue&type=script&lang=ts"
export * from "./ag-grid-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./ag-grid-wrapper.vue?vue&type=style&index=0&id=e26a1c20&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
